var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-5 basic"},[_vm._v(" 오류 신고는 좀 더 편리한 신고를 위해 카페로 이전되었습니다."),_c('br'),_c('v-btn',{attrs:{"text":"","href":"https://cafe.naver.com/hibernating/menu/58","target":"_blank"}},[_vm._v(" 오류 신고 바로가기 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }